import { ReactNode } from "react";
import { Pressable } from "react-native";

export const MenuOption = ({
  onSelect,
  children,
  className,
}: {
  onSelect: () => void;
  children: ReactNode;
  className?: string;
}) => {
  return (
    <Pressable
      onPress={onSelect}
      className={`p-2 hover:bg-gray-100 rounded-md cursor-pointer ${className}`}
    >
      {children}
    </Pressable>
  );
};
